import { render, staticRenderFns } from "./BsiCartSummary.vue?vue&type=template&id=8783f8da&scoped=true"
import script from "./BsiCartSummary.vue?vue&type=script&lang=js"
export * from "./BsiCartSummary.vue?vue&type=script&lang=js"
import style0 from "./BsiCartSummary.vue?vue&type=style&index=0&id=8783f8da&prod&lang=scss&scoped=true"
import style1 from "./BsiCartSummary.vue?vue&type=style&index=1&id=8783f8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8783f8da",
  null
  
)

export default component.exports